import { JobTitle } from '@pflegia/data-access';
import { FunnelQuestion, FunnelQuestionCategory } from '@pflegia/types/api/funnel/questions';
import { LocalFunnelStep } from '@pflegia/ui/funnel/types';
import { FunnelAnswers } from '@pflegia/ui/pflegia/funnel/types/funnel-answers';

const KEY = FunnelQuestion.EmploymentType;

export const employmentTypeStep: LocalFunnelStep<JobTitle, FunnelAnswers, FunnelQuestion.EmploymentType> = {
  category: FunnelQuestionCategory.AboutYou,
  key: KEY,
};
